import { graphql } from 'react-relay';

export default graphql`
  query OutstandingPaymentsQuery_OutstandingPayments_Query(
    $outstanding_payments_before: ISO8601Type
    $outstanding_payments_after: ISO8601Type
    $count: Int!
    $cursor: String
  ) {
    viewer {
      ...OutstandingPaymentsContainer_viewer @arguments(
        outstanding_payments_before: $outstanding_payments_before
        outstanding_payments_after: $outstanding_payments_after
        count: $count
        cursor: $cursor
      )
    }
  }
`;



// WEBPACK FOOTER //
// ./webpack/routes/OutstandingPaymentsQuery.js